import React from "react";
import styled from "styled-components";
import Layout from "../../containers/layout";
import { fontSize } from "../../styles/Font";

const PageWrapper = styled.div`
  position: relative;
`;
const BackgroundWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  position: static;
`;
const BackgroundImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -100;
  background-position: 50%;
  background-size: cover;
  margin: auto;
  position: absolute;
`;
const BackgroundView = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: -100;
`;
const HeaderWrapper = styled.div`
  padding-top: 12.5%;
  padding-bottom: 5%;
`;
const HeaderTitle = styled.div`
  ${fontSize(70, "L", "white")}
  padding: 1% 0px;
`;
const HeaderDesc = styled.div`
  ${fontSize(20, "L", "white")}
`;

const ContactHeader = () => {
  return (
    <section>
      <PageWrapper>
        <BackgroundWrapper>
          <BackgroundImage src="https://d17mmzdc0h66bb.cloudfront.net/image/contact_background.png" />
        </BackgroundWrapper>
        <BackgroundView />
        <Layout>
          <HeaderWrapper>
            <HeaderTitle>문의하기</HeaderTitle>
            <HeaderDesc>
              지역별 담당자 및 문의처를 확인할 수 있습니다.
            </HeaderDesc>
          </HeaderWrapper>
        </Layout>
      </PageWrapper>
    </section>
  );
};

export default ContactHeader;
